export default __webpack_public_path__ + "static/media/footerWave.96748cf4.svg";